import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ light = false, className = "" }) {
  return (
    <Link to="/" className={`inline-flex items-center select-none ${className}`} data-testid="brand-logo">
      <span className="font-serif font-bold tracking-tight text-[1.5rem] md:text-[1.7rem] leading-none"
            style={{ color: "#C6A45C" }}>
        PENICH
      </span>
      <span className="ml-1.5 inline-flex items-center rounded-[3px] px-2 py-0.5"
            style={{ background: light ? "#0B2748" : "#0B2748" }}>
        <span className="font-serif font-bold text-[1.25rem] md:text-[1.4rem] leading-none text-white">ART</span>
        <svg width="20" height="20" viewBox="0 0 24 24" className="ml-1 -rotate-12" fill="none">
          <path d="M14 3l5 5-7 7-5-5 7-7z" fill="#C6A45C"/>
          <path d="M7 10l-3 7 7-3" fill="#fff" stroke="#C6A45C" strokeWidth="0.5"/>
        </svg>
      </span>
    </Link>
  );
}
